import React from "react";
import { SimpleTextInputCard } from "sortation/components/SimpleTextInputCard";
import { useStagingScan } from "./useStagingScan";

export const StagingScan = () => {
  const { barcode, isLoading, setBarcode, handleStagingScan } = useStagingScan();

  return (
    <SimpleTextInputCard
      title="Scan Gaylord Barcode"
      label="Gaylord ID"
      value={barcode}
      onSubmit={handleStagingScan}
      onChange={setBarcode}
      disabled={isLoading}
      debounceSubsequent
    />
  );
};
